var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeezer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 195.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #40ab5d;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-5);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 109.44,
    y1: 86.28,
    x2: 109.19,
    y2: 102.07,
    gradientTransform: "translate(-1.46 303.24) scale(2.46 -2.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#358c7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#33a65e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 95.73,
    y1: 65.83,
    x2: 122.89,
    y2: 79.66,
    gradientTransform: "translate(-1.46 303.24) scale(2.46 -2.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#222b90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367b99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.59,
    y1: 51.36,
    x2: 26.95,
    y2: 51.36,
    gradientTransform: "translate(-1.46 303.24) scale(2.46 -2.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 32.45,
    y1: 51.36,
    x2: 58.78,
    y2: 51.36,
    gradientTransform: "translate(-1.46 303.24) scale(2.46 -2.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc1953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 64.3,
    y1: 51.36,
    x2: 90.63,
    y2: 51.36,
    gradientTransform: "translate(-1.46 303.24) scale(2.46 -2.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 96.14,
    y1: 51.36,
    x2: 122.49,
    y2: 51.36,
    gradientTransform: "translate(-1.46 303.24) scale(2.46 -2.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#222b90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3559a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 63.26,
    y1: 68.59,
    x2: 91.7,
    y2: 76.9,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 31.48,
    y1: 77.89,
    x2: 59.72,
    y2: 67.6,
    gradientTransform: "translate(-1.46 303.24) scale(2.46 -2.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce1938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 34.66,
    y1: 104.22,
    x2: 56.59,
    y2: 84,
    gradientTransform: "translate(-1.46 303.24) scale(2.46 -2.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd5a22"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Deezer"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m300,0v37.95h-64.86V0h64.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m300,52.6v37.95h-64.86v-37.95h64.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m300,105.23v37.95h-64.86v-37.95h64.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m64.86,157.86v37.95H0v-37.95h64.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m143.21,157.86v37.95h-64.89v-37.95h64.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m221.68,157.86v37.95h-64.89v-37.95h64.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m300,157.86v37.95h-64.86v-37.95h64.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m221.68,105.23v37.95h-64.89v-37.95h64.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m143.21,105.23v37.95h-64.89v-37.95h64.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m143.21,52.6v37.95h-64.89v-37.95h64.89Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeezer);
export default __webpack_public_path__ + "static/media/Deezer.3ed67bdc6a782968b18e720683965d67.svg";
export { ForwardRef as ReactComponent };